import React, { useEffect, useState } from "react";
import _ from "lodash";
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  Cell,
} from "@table-library/react-table-library/table";
import { useLocation } from "react-router";
import GetAppIcon from "@material-ui/icons/GetApp";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import {
  createStyles,
  Grid,
  makeStyles,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Icon } from "@iconify/react";
import {
  HeaderCellSort,
  useSort,
} from "@table-library/react-table-library/sort";
import "jspdf-autotable";

import { CustomTheme } from "../../../../types/customTheme";
import CardCommon from "../../../../components/card/CardCommon";
import MenuButtonCommon from "../../../../components/buttons/MenuButtonCommon";
import { getFilterListFromArrayObject } from "../../../../utils/commonArrayMap";
import { convertDecimalPoint } from "../../../../utils/ReplaceIcon";
import SaleDetailsModal from "../../../../components/common/SaleDetailsModal";
import LocationDetailsCard from "../../../../components/common/LocationDetailsCard";
import TextfieldCommon from "../../../../components/textField/TextfieldCommon";
import TextfieldDefault from "../../../../components/textField/TextfieldDefault";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import ValidationMessage from "../../../../components/validation/ValidationMessage";
import TextfieldDefaultNew from "../../../../components/textField/TextfieldDefaultNew";
import TextFieldCustom from "../../../../components/textField/TextFieldCustom";

export interface VoidSummeryInfoNodeProps {
  orderId: any;
  setOrderId: any;
  handleGetLogsInfo: any;
  handleSubmitGeneric: any;
  handleSubmitKds: any;
}

const useStyles = (nodesLength: number, nodesHeadersLength: number) =>
  makeStyles((theme: CustomTheme) => createStyles({}));

/**
 * FilterOption Component:
 *
 * This component is responsible for rendering the table displaying void summary information
 * for different locations and VAT percentages. It also provides options for exporting the data
 * as PDF or CSV files. The table allows sorting by columns and supports responsive layout
 * adjustments based on screen size.
 */
const FilterOption: React.FunctionComponent<VoidSummeryInfoNodeProps> = ({
  orderId,
  setOrderId,
  handleGetLogsInfo,
  handleSubmitGeneric,
  handleSubmitKds,
}) => {
  const [error, setError] = useState("");
  const isValid = (input: any) =>
    /^(?![._])(?=.*[._])[0-9._]+(?<![._])$/.test(input);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    const filtered = input.replace(/[^0-9._]/g, ""); // only allow numbers, dot, underscore
    setError("");
    setOrderId(filtered);
  };

  const handleSubmit = () => {
    if (isValid(orderId)) {
      handleGetLogsInfo();
    } else {
      // Optionally show an error or do nothing
      setError("Invalid Order No. Must contain . or _");
    }
  };

  const theme: CustomTheme = useTheme();
  return (
    <div style={{ marginTop: "40px" }}>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <CardCommon
            style={{ height: "86px" }}
            backgroundColor={"entity_background"}
          >
            <Grid container>
              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  padding: "21px",
                }}
              >
                <ButtonCommon
                  color={"blue"}
                  style={{ width: "100%", fontSize: "14px" }}
                  onClick={handleSubmitGeneric}
                >
                  Show Generic Logs
                </ButtonCommon>
                <ButtonCommon
                  color={"blue"}
                  style={{ width: "80%", marginLeft: "18px", fontSize: "14px" }}
                  onClick={handleSubmitKds}
                >
                  Show KDS Logs
                </ButtonCommon>
              </Grid>
            </Grid>
          </CardCommon>
        </Grid>
        <Grid item xs={8}>
          <CardCommon backgroundColor={"entity_background"}>
            <Grid container>
              <Grid item xs={4} style={{ padding: "11px" }}>
                <TextFieldCustom
                  id="sign-email-input"
                  name="sign-email-input"
                  style={{ width: "100%" }}
                  label="Order No"
                  onChange={handleChange}
                  value={orderId}
                  type="text"
                  onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                    if (e.key === "Enter") {
                      handleSubmit();
                    }
                  }}
                />
                <ValidationMessage message={error} />
              </Grid>
              <Grid item xs={4}></Grid>
              <Grid
                item
                xs={4}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  paddingRight: "12px",
                }}
              >
                <ButtonCommon
                  color={"green"}
                  style={{ width: "180px", fontSize: "14px" }}
                  onClick={handleSubmit}
                >
                  Search Order Logs
                </ButtonCommon>
              </Grid>
            </Grid>
          </CardCommon>
        </Grid>
      </Grid>
    </div>
  );
};

export default FilterOption;
